import { trpc } from "~/utils/trpc";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import TextType from "@quake/shared-ui/components/TextType";
import Logo from "@assets/images/quake_logo.svg";
export const Route = createFileRoute("/_public")({
  component: RouteComponent,
});

function RouteComponent() {
  const { data: unsplashUrl, status: unsplashStatus } = useQuery(trpc.auth.getSplashPhoto.queryOptions());
  return (
    <div className="flex min-h-screen w-full">
      {/* Image Section */}
      <div className="hidden lg:block lg:w-1/2 relative">
        {unsplashStatus === "pending" ? (
          <div className="absolute inset-0 bg-gray-200 motion-preset-blink" />
        ) : (
          <img src={unsplashUrl} alt="Nature background" className="absolute inset-0 h-full w-full object-cover" />
        )}
        <div className="absolute inset-0 bg-linear-to-r from-black/50 to-transparent flex items-center justify-center">
          <div className="px-8 text-white">
            <img src={Logo} alt="Quake Logo" className="h-12 mb-6 mx-auto invert" />
            <TextType
              text={[
                "Automation Built For Recruitment...",
                "AI Agents Built For Recruitment...",
                "Recruit smarter. Automate faster...",
              ]}
              typingSpeed={75}
              pauseDuration={3500}
              showCursor={true}
              cursorCharacter="|"
            />
          </div>
        </div>
      </div>
      <div className="w-full lg:w-1/2 flex items-center justify-center p-4 md:p-8 bg-background">
        <Outlet />
      </div>
    </div>
  );
}
